import { Injectable } from '@angular/core';
import { Jsonp, RequestOptions, Http, Headers, ResponseContentType } from '@angular/http';
import { ApiService } from 'app/services/common/api.service';

@Injectable()
export class QuanlyrepeaterService {

  constructor(private api: ApiService) { }
  uploadExcelReturnJson(desFolder: string, overWrite: string, file: File,danhmucid) {
    let formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name);
    formData.append('Desfolder', desFolder);
    formData.append('overWrite', overWrite);
    formData.append('danhmucid', danhmucid);
    let headers = new Headers()
    //headers.append('Content-Type', 'json');  
    //headers.append('Accept', 'application/json');  
    let options = new RequestOptions({ headers: headers });
    return this.api.Excute("api/repeater/UploadExcelReturnJson", formData, options);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/quan-ly/repeater/quanlyrepeater.service.ts